export default __webpack_public_path__ + "static/media/close.cd8a2343.svg";